module.exports = __webpack_public_path__ + "static/media/toy_page02.cb9599ba.gif";